import { useFormik } from 'formik';
import { Button, TextField } from '@mui/material';

import validationSchemas from 'utils/validationSchemas';

const SignUpForm = ({ onSubmit }) => {
	const formik = useFormik({
		initialValues: {
			name: '',
			lastName: '',
			email: '',
			phone: '',
			password: '',
			confirmPassword: '',
		},
		validationSchema: validationSchemas.signUp,
		onSubmit,
	});

	return (
		<div className="SignUpForm">
			<form onSubmit={formik.handleSubmit}>
				<TextField
					fullWidth
					id="lastName"
					name="lastName"
					label="Apellidos"
					value={formik.values.lastName}
					onChange={formik.handleChange}
					error={formik.touched.lastName && Boolean(formik.errors.lastName)}
					helperText={formik.touched.lastName && formik.errors.lastName}
					margin="normal"
				/>
				<TextField
					fullWidth
					id="name"
					name="name"
					label="Nombres"
					value={formik.values.name}
					onChange={formik.handleChange}
					error={formik.touched.name && Boolean(formik.errors.name)}
					helperText={formik.touched.name && formik.errors.name}
					margin="normal"
				/>
				<TextField
					fullWidth
					id="email"
					name="email"
					label="Correo electrónico"
					value={formik.values.email}
					onChange={formik.handleChange}
					error={formik.touched.email && Boolean(formik.errors.email)}
					helperText={formik.touched.email && formik.errors.email}
					margin="normal"
				/>
				<TextField
					fullWidth
					id="phone"
					name="phone"
					label="Teléfono celular"
					value={formik.values.phone}
					onChange={formik.handleChange}
					error={formik.touched.phone && Boolean(formik.errors.phone)}
					helperText={formik.touched.phone && formik.errors.phone}
					margin="normal"
				/>
				<TextField
					fullWidth
					id="password"
					name="password"
					label="Contraseña"
					type="password"
					value={formik.values.password}
					onChange={formik.handleChange}
					error={formik.touched.password && Boolean(formik.errors.password)}
					helperText={formik.touched.password && formik.errors.password}
					margin="normal"
				/>
				<TextField
					fullWidth
					id="confirmPassword"
					name="confirmPassword"
					label="Confirma tu contraseña"
					type="password"
					value={formik.values.confirmPassword}
					onChange={formik.handleChange}
					error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
					helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
					margin="normal"
				/>
				<Button variant="contained" fullWidth type="submit" size="large" sx={{ mt: 2 }}>
					Enviar solicitud
				</Button>
			</form>
		</div>
	);
};

export default SignUpForm;
